import { render, staticRenderFns } from "./CraftList.vue?vue&type=template&id=50b5ead6&scoped=true"
import script from "./CraftList.vue?vue&type=script&lang=js"
export * from "./CraftList.vue?vue&type=script&lang=js"
import style0 from "./CraftList.vue?vue&type=style&index=0&id=50b5ead6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b5ead6",
  null
  
)

export default component.exports